import { Dialog } from "@headlessui/react";
import Button from "../../../components/button/Button";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { Company, companySchema, initialCompany } from "../../../model/Companies";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import "../../../utility/ValidationUtilty";
import { useEffect } from "react";
import FormController from "../../../components/fields/FormController";
import { FormBox, ModalFoterBox, ModalHeaderBox } from '../../../components/box/Box';
import { Label } from "../../../components/fields/Fields";

export type CompaniesProps = {
  company?: Company;
  onSubmit: (data: Company) => Promise<void>;
};

export const CompaniesEditModal = ({
  open,
  toggle,
  closeOnClickOutside,
  updateFlg,
  company = initialCompany(),
  onSubmit,
}: ModalProp & CompaniesProps) => {
  const { control, handleSubmit, setValue, reset } = useForm<Company>({
    resolver: yupResolver(companySchema),
    defaultValues: company,
  });

  useEffect(() => {
    if (updateFlg) {
      setValue("id", company.id);
      setValue("displayId", company.displayId);
      setValue("name", company.name);
      setValue("nameKana", company.nameKana);
      setValue("managerEmail", company.managerEmail);
      setValue("managerName", company.managerName);
      setValue("managerNameKana", company.managerNameKana);
      setValue("usersCount", company.usersCount);
    }
  }, [
    company.id,
    company.displayId,
    company.managerEmail,
    company.managerName,
    company.managerNameKana,
    company.name,
    company.nameKana,
    company.usersCount,
    setValue,
    updateFlg,
    open
  ]);

  useEffect(() => {
    if(!open) {
      reset();
    };
  },[open, reset]);

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <form
          className=""
          onSubmit={handleSubmit(onSubmit)}
          method="POST"
          noValidate
        >
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center mt-3">
              <ModalHeaderBox
                title={`団体の${updateFlg ? '編集' :'登録'}`}
                Subtitle={`${updateFlg ? '変更' : '新規契約'}する団体情報を入力してください`}
              />
              <FormBox>
                {company.id !== '' ?
                (<div className={'flex flex-col h-full'}>
                    <Label id={"displayId"}>団体番号</Label>
                    <div className="h-full p-2 justify-center">
                      {company.displayId}
                    </div>
                  </div>)
                :(<FormController
                  control={control}
                  name={"displayId"}
                  label={"団体番号"}
                  type={"text"}
                  required
                />)}
                <FormController
                  control={control}
                  name={"usersCount"}
                  label={"契約数"}
                  min={0}
                  type={"number"}
                  required
                />
              </FormBox>
              <FormBox>
                <FormController
                  control={control}
                  name={"name"}
                  label={"団体名"}
                  type={"text"}
                  required
                />
                <FormController
                  control={control}
                  name={"nameKana"}
                  label={"団体名カナ"}
                  type={"text"}
                  required
                />
              </FormBox>
              <FormBox>
                <FormController
                  control={control}
                  name={"managerName"}
                  label={"担当者名"}
                  type={"text"}
                  required
                />
                <FormController
                  control={control}
                  name={"managerNameKana"}
                  label={"担当者名カナ"}
                  type={"text"}
                  required
                />
                <FormController
                  control={control}
                  name={"managerEmail"}
                  label={"担当者メールアドレス"}
                  type={"email"}
                  required
                />
              </FormBox>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              color={"indigo"}
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 w-[132px]"
              submit
              children={"登録"}
            />
          </ModalFoterBox>
        </form>
      </Dialog.Panel>
    </Modal>
  );
};
